// Using double quotes in this file to prevent issues with apostrophes (')
export default {
  header: {
    ai: {
      title: 'HP Nio에게 물어보기',
      close: 'Nio 채팅 닫기',
      open: 'Nio 채팅 열기',
      morningGreeting: "{0}님, 상쾌한 아침입니다.",
      afternoonGreeting: "{0}님, 화창한 오후입니다.",
      eveningGreeting: "{0}님, 편안한 저녁 되세요.",
      morningGreetingGeneric: "상쾌한 아침입니다,",
      afternoonGreetingGeneric: "화창한 오후입니다,",
      eveningGreetingGeneric: "편안한 저녁 되세요,",
      opening: "저는 Nio입니다. 어떻게 도와드릴까요?",
      openingPrivacy: "저는 Nio입니다.",
      pbIntro1: "장치의 생산성에 대해 물어보세요.",
      alertDefault: "Nio는 초기 베타 버전입니다. 답변은 현재 PrintBeat와 지식 존으로 제한되어 있습니다.",
      intro2:  "다음과 같은 몇 가지 흥미로운 질문이 있습니다.",
      kzIntro1: "여러분의 우려 사항을 저에게 물어보세요. 지식 존 정보를 바탕으로 답변해 드리겠습니다.",
      pbSample1: "사이트의 어제 생산성은 어느 정도였나요?",
      pbSample2: "생산성을 어떻게 향상시킬 수 있나요?",
      pbSample3: "다른 프레스보다 성능이 더 좋은 프레스는 어느 프레스인가요?",
      pbSample4: "가장 시간 손실이 많은 피인쇄체는 어느 것인가요?",
      pbSample5: "지난 주에 가장 시간 낭비가 많았던 문제는 무엇인가요?",
      kzSample1: "품질을 유지하고 비용을 절감하면서 피인쇄체 폐기를 줄이려면 어떻게 해야 합니까?",
      kzSample2: "효율적이고 색상 일관성이 있는 와인 라벨 인쇄에 가장 적절한 HP Indigo 프레스는 무엇인가요?",
      kzSample3: "생산성을 높이기 위해 소모품 사용을 최적화하려면 어떻게 해야 합니까?",
      kzSample4: "인쇄할 때 고려해야 할 주요 지속 가능성 요소는 무엇입니까?",
      kzSample5: "HP Indigo 6000과 20K 프레스에서 색상 일관성을 보장하려면 어떻게 해야 합니까?",
      feedbackTitle: "점수 이유",
      feedbackPlaceholder: "무슨 일이 일어났는지 자세히 설명해 주실 수 있습니까?",
      fbPositive1: "데이터가 정확함",
      fbPositive2: "대응이 매우 좋음",
      fbPositive3: "매우 자세함",
      fbPositive4: "답변이 적절함",
      fbOther: "기타",
      fbNegative1: "정보 또는 데이터가 정확하지 않음",
      fbNegative2: "대응이 내 질문을 해결하지 못함",
      fbNegative3: "대응이 혼란스럽거나 불확실함",
      fbNegative4: "답변이 적절하지 않음",
      feedbackSubmittedTitle: "피드백에 감사드립니다!",
      feedbackSubmittedDescription_Positive: "대응이 도움이 되었다니 다행입니다! 고객님의 소중한 의견은 저희가 더 나은 경험을 제공할 수 있도록 하는 원동력이 됩니다.",
      feedbackSubmittedDescription_Negative: "불편을 끼쳐드려 죄송합니다. 저희 팀에서 해당 정보를 검토하여 수정하도록 하겠습니다. 오류에 대한 자세한 내용이나 추가 의견이 있으시면 알려주시면 개선에 도움이 될 것입니다.",
      ask_Placeholder: "알고 싶으신 것이 무엇입니까?",
      answerCopiedToClipboard: "답변이 클립보드에 복사됨",
      feedbackSubmitted: "피드백 제출됨",
      feedbackCleared: "피드백 제거됨",
      newConversation: "새 채팅",
      chatHistory: "채팅 기록",
      submitQuestion: "질문 제출",
      responseError: "죄송합니다. 저희 측에 문제가 발생한 것 같습니다. 나중에 다시 시도해 주십시오. 문제가 지속되면 지원팀에 문의해 주십시오.",
      responseError400: "질문에 예상치 못한 문자가 포함된 것 같습니다. 계속하려면 해당 부분을 제거해 주십시오.",
      responseError429: "속도를 조금 늦춰 주십시오. 질문이 너무 많아서 따라갈 수가 없습니다.",
      like: "좋아요",
      dislike: "싫어요",
      copy: "클립보드로 복사",
      retry: "재시도",
      contact: "연락처",
      contactSubject: "HP Nio 문제",
      contactQuestion: "문의: {0}",
      noConversations: "대화 없음",
      startConversation: "채팅 기록을 확인하려면 여기에서 대화를 시작",
      today: "오늘",
      yesterday: "어제",
      privacyNotice: "AI 솔루션과 상호 작용하고 있습니다. 답변이 불완전하거나 부정확할 수 있으므로 검토하시기 바랍니다.",
      privacy1: "AI 솔루션을 사용하려고 합니다. 채팅 내용은 검토 후 모델 학습에 활용될 수 있습니다.",
      privacy2: `If you prefer to receive support in another way, please visit {0}.`,
      acceptPrivacy: "HP Nio와 채팅 시작하기",
      deleteConversationTitle: "대화 삭제",
      conversationName: "대화",
      deleteConversationConfirm: "<b>{0}</b>이(가) 삭제될 것입니다.",
      deleteConversationSuccess: "대화 삭제됨",
      deleteConversationError: "대화를 삭제할 수 없음",
      renameConversationTitle: "대화 이름 변경",
      renameConversationMessage: "대화 이름",
      renameConversationSuccess: "대화 이름 변경됨",
      renameConversationError: "대화 이름을 변경할 수 없음",
      deleteConversation: "삭제",
      renameConversation: "이름 바꾸기",
    },
    apps: {
      title: "메뉴",
      externalLinks: "외부",
      availableApps: "탐색",
      configure: "사용자 지정",
      showApp: "표시",
      hideApp: "숨기기",
      setDefault: "기본 애플리케이션 설정",
      setShortcut: "고정으로 설정",
      removeShortcut: "고정 해제",
      showAllApps: "모든 애플리케이션 표시",
      shortCutTooltip: "{0}(으)로 이동",
      currentAccount: "현재 조직",
      goHome: "홈으로 이동",
      goAppHome: "애플리케이션 시작 페이지로 이동",
      byProvider: "- {0}",
      quickFilter: "애플리케이션 찾기...",
      allApps: "모든 애플리케이션",
      recentApps: "최근",
      externalApp: "PrintOS의 외부에 있는 애플리케이션",
      modeSwitcher: "어두운/밝은 모드",
      goProducts: "더 많은 앱 검색"
    },
    panels: {
      ai: "HP Nio에게 물어보기",
      notifications: "내 알림",
      help: "도움말 및 지원",
      user: "사용자",
      close: "패널 닫기",
      moveLeft: "왼쪽 이동",
      moveRight: "오른쪽 이동",
      maximize: "최대화",
      restore: "복원",
    },
    user: {
      account: "조직",
      returnToHP: "HP Inc.로 되돌아가기",
      myOrganization: "내 조직",
      myOrganizations: "내 조직",
      myReports: "내 보고서",
      mySettings: "내 설정",
      signOut: "로그아웃",
      signInExplanation: "귀하의 알림 및 애플리케이션을 보려면 HP PrintOS로 로그인하십시오.",
      signIn: "로그인",
      RCDA: "고객 액세스",
      orphanUser: "PrintOS 사용자",
      orphanContext: "조직 없음",
      deviceUser: "PrintOS 장치",
      anonymous: "익명 사용자",
      name: "이름",
      email: "이메일",
      address: "주소",
      editUser: "HP 계정 편집",
      viewPrivacy: "개인 정보 보호 정책 보기"
    },
    date: {
      fewSecondsAgo: "몇 초 전",
      minuteAgo: "1분 전",
      minutesAgo: "{0}분 전",
      hourAgo: "1시간 전",
      hoursAgo: "{0}시간 전",
      dayAgo: "1일 전",
      daysAgo: "{0}일 전",
      monthAgo: "1개월 전",
      monthsAgo: "{0}개월 전",
      yearAgo: "1년 전",
      yearsAgo: "{0}년 전",
    },
    help: {
      quickFilter: "검색",
      page: "페이지",
      app: "애플리케이션",
      newFeatures: "새 기능",
      more: "모두",
      contactHP: "HP 문의",
      noTopics: "일치하는 도움말 항목 없음",
      about: "정보",
      terms: "사용 약관",
      readFile: "문서",
      stepByStepTutorial: "사용 지침서",
      goLink: "애플리케이션 페이지",
      viewVideo: "비디오",
      goToUrl: "링크",
      other: "기타",
      faq: "자주 묻는 질문",
      new: "새 항목",
      whatsNew: "새 소식",
      technicalSupport: "PrintOS 지원",
      printOSFeedback: "PrintOS 피드백",
      conversationsWithHP: "HP와 대화",
      youMayConsider: "고려 사항...",
      myKzArticles: "My Knowledge Zone 문서",
      kzServiceTopics: "{0}({1})",
      lkcArticles: "HP Latex Knowledge Center 문서",
    },
    notifications: {
      noNotifications: "알림 없음",
      viewAll: "모두 보기",
      dismiss: "취소",
      dismissAll: "모두 취소",
      subscriptions: "설정",
    },
    marketplace: {
      title: "마켓플레이스",
      explore: "모두 탐색",
      featured: "추천",
      slides: {
        default: {
          description: "프리미엄 애플리케이션, 확장 기능 및 커넥터로 PrintOS 향상"
        },
        oee: {
          title: "Print Beat OEE",
          description: "실시간에 가까운 데이터 중심 인사이트로 작업 효율성 추진",
        },
      },
      partialProductivitySubscribePreEnforcement_Title: "Indigo Print Beat, Jobs, OEE 및 Print Beat 서비스를 이용하려면 8월 4일부터 <a href='https:/intercom.help/hp-printos/en/articles/11113950-hp-printos-productivity-power-pack' target='_blank'>제품 파워 팩 구독</a>이 필요합니다.",
      partialProductivitySubscribePreEnforcement_Desc: "구독 취소된 기기의 데이터는 8월 이전에 추출할 수 있습니다.",
      partialProductivitySubscribePostEnforcement_Title: "일부 Indigo 기기는 제품 파워 팩({0}/{1})에 가입되어 있지 않습니다.",
      partialProductivitySubscribePostEnforcement_Desc: "구독하지 않은 기기에서는 PrintOS 환경(Print Beat, 작업, OEE, 대시보드 등)이 제한될 수 있습니다.",
      goToMarket_Action: "마켓플레이스로 이동",
      howToExtract_Action: "내 데이터 추출 방법"
    },
    focus: {
      title: "Focus",
    },
    locales: {
      "de-DE": "독일어",
      "en-GB": "영어(영국)",
      "en-US": "영어(미국)",
      "es-ES": "스페인어",
      "fr-FR": "프랑스어",
      "it-IT": "이탈리아어",
      "ja-JP": "일본어",
      "ko-KO": "한국어",
      "pt-PT": "포르투갈어",
      "tr-TR": "터키어",
      "zh-HANS": "중국어(간체)",
      "ru-RU": "러시아어",
      "부분 변환": "부분 변환",
    },
    modal: {
      ok: "확인",
      cancel: "취소",
    },
    combo: {
      noItems: "일치하는 항목 없음",
    },
    nps: {
      question: "{0}님 안녕하세요. PrintOS를 친구에게 추천하겠습니까?",
      // In case we can't get user's display name
      questionNameless: "PrintOS를 친구에게 추천하겠습니까?",
      notLikely: "전혀 그렇지 않음",
      likely: "적극 추천",
      send: "피드백 보내기",
      response: {
        detractor: "{0}, 귀하의 PrintOS 환경을 개선할 수 있는 한 가지 방법은 무엇입니까? 모든 의견을 검토합니다.",
        detractorNameless: "귀하의 PrintOS 환경을 개선할 수 있는 한 가지 방법은 무엇입니까? 모든 의견을 검토합니다.",
        passive: "{0}, PrintOS 환경을 개선할 방법이 있으면 알려주십시오. 모든 의견을 검토합니다.",
        passiveNameless: "PrintOS 환경을 개선할 방법이 있으면 알려주십시오. 모든 의견을 검토합니다.",
        promoter: "{0}, PrintOS가 마음에 드셨다니 기쁩니다! 이유를 알려주십시오. 모든 의견을 검토합니다.",
        promoterNameless: "PrintOS가 마음에 드셨다니 기쁩니다! 이유를 알려주십시오. 모든 의견을 검토합니다.",
      },
      introMorning: "{0}님, 안녕하세요. PrintOS의 고객 성공 관리자인 Jon입니다.",
      introMorningNameless: "안녕하세요. PrintOS의 고객 성공 관리자인 Jon입니다.",
      introAfternoon: "{0}님, 안녕하세요. PrintOS의 고객 성공 관리자인 Jon입니다.",
      introAfternoonNameless: "안녕하세요. PrintOS의 고객 성공 관리자인 Jon입니다.",
      introEvening: "{0}님, 안녕하세요. PrintOS의 고객 성공 관리자인 Jon입니다.",
      introEveningNameless: "안녕하세요. PrintOS의 고객 성공 관리자인 Jon입니다.",
      intro2: "이 질문에 대답해 주시면 귀하의 PrintOS 경험을 이해하는 데 도움이 됩니다.",
      intro3: "PrintOS를 친구에게 추천하겠습니까?",
      detractorResponse: "{0}님, 답변해 주셔서 감사합니다! 당사는 긍정적이고 비판적인 피드백을 모두 소중하게 생각합니다.",
      detractorResponseNameless: "답변해 주셔서 감사합니다! 당사는 긍정적이고 비판적인 피드백을 모두 소중하게 생각합니다.",
      promoterResponse: "{0}님, 감사합니다! PrintOS의 팬이라니 정말 기쁩니다. 귀하의 피드백은 최상의 경험을 제공하는 데 많은 도움이 될 수 있습니다.",
      promoterResponseNameless: "감사합니다! PrintOS의 팬이라니 정말 기쁩니다. 귀하의 피드백은 최상의 경험을 제공하는 데 많은 도움이 될 수 있습니다.",
      response2: "애플리케이션을 선택하고 PrintOS의 개선이 필요한 사항이 있으면 알려주십시오.",
      response3: "모든 의견은 고객 성공 팀에서 검토합니다. 피드백을 더 잘 이해하기 위해 연락을 드릴 수도 있습니다.",
      feedbackPlaceholder: "다음을 통해 PrintOS를 개선할 수 있습니다...",
      application: "애플리케이션",
      noApplication: "PrintOS - 일반 피드백"
    },
    subscription: {
      title: "구독",
      subscribe: "지금 구독!",
      noticeSingular: "귀하의 {0} 구독이 {1}일 후에 만료됩니다.",
      notice: "귀하의 {0} 구독이 {1}일 후에 만료됩니다.",
    },
    promotion: {
      label: "프로모션",
      title: "프로모션 기간 알림",
      notice: "이 애플리케이션에 대한 프로모션 기간입니다.",
    },
    trial: {
      label: "평가판이 곧 만료됨",
      title: "평가판 기간",
      noticeSingular: "{0}은(는) 평가판 사용 기간 중입니다. 귀하의 평가판은 {1}일 안에 만료됩니다.",
      notice: "{0}은(는) 평가판 사용 기간 중입니다. 귀하의 평가판은 {1}일 안에 만료됩니다.",
    },
    subscriptionExpired: {
      label: "구독이 만료됨",
      title: "구독이 만료됨",
      notice: "{0}에 대한 귀하의 구독이 만료되었습니다.  짧은 유예 기간이 지나면 더 이상 이 기능을 액세스할 수 없게 됩니다.",
    },
    trialExpired: {
      label: "평가판이 만료됨",
      title: "평가판 기간이 만료됨",
      notice: "{0}에 대한 귀하의 평가판 기간이 만료되었습니다.  짧은 유예 기간이 지나면 더 이상 이 기능을 액세스할 수 없게 됩니다.",
    },
    hpWarning: "{0}\n귀하는 고객 조직에서 HP Inc. 담당자입니다.  주의하시기 바랍니다.",
    role: {
      HP_Operation: "HP 사업",
      HP_Sales_and_Marketing: "HP 고객 응대",
      SystemRoleGenesis_Admin: "PrintOS 서비스 관리자",
      SystemRoleGenesis_Support: "HP Inc. 관리자",
      SystemRoleGenesis_R_AND_D: "Genesis R&D",
      CE_Level_1: "CE 레벨 1",
      CE_Level_2: "CE 레벨 2",
      Application_Engineer: "애플리케이션 엔지니어",
      Ramp_Up_Engineer: "램프 업 엔지니어",
      Support_Engineer: "지원 엔지니어",
      Remote_Support_Engineer: "HP 지원 엔지니어",
      Specialist: "전문가",
      Certification_Centers: "인증 센터",
      Supplies_and_Media_Personnel: "소모품 및 용지 담당자",
      Supplies_and_Media_Admin: "소모품 및 피인쇄체 매니저",
      HP_Service: "HP 서비스",
      HP_Training: "HP 교육",
      Admin: "관리자",
      Pre_Press_Operator: "사용자",
      Press_Operator: "작동자",
      Dashboard: "대시보드",
      Channel_Sales_and_Marketing: "채널 영업 및 마케팅",
      Channel_Operation: "채널 사업",
      Channel_CE_Level_1: "채널 CE 레벨 1",
      Channel_CE_Level_2: "채널 CE 레벨 2",
      HP_Read_Only: "HP 읽기 전용",
      Reseller_Manager: "리셀러 관리자",
      Business_Partner_Manager: "사업 파트너 관리자",
      Call_Center: "콜 센터",
      Field_Engineer: "현장 엔지니어",
      ThreeD_Business_Manager: "3D 사업 관리자",
      HPInPsp: "PSP의 HP",
      ChannelInPsp: "PSP의 채널",
      GenericAdmin: "관리자",
      GenericUser1: "사용자 레벨 1",
      GenericUser2: "사용자 레벨 2",
      Generic_Read_Only: "읽기 전용",
      ThreeD_Care_Center: "3D Care Center",
      ThreeD_Cost_Calculator: "3D 비용",
      Composer_External: "제한된 액세스 - 컴포저",
      SIM_External: "제한된 액세스 - 소모품 재고 관리자",
      Multiple: "여러 역할"
    },
    inlineAlerts: {
      Http_429_Error: "높은 트래픽",
      Http_429_Description: "현재 서비스에 비정상적인 로드가 발생하고 있습니다. 일부 기능을 일시적으로 사용하지 못할 수 있습니다. 다시 시도하려면 페이지를 새로 고치세요.",
      Http_429_Action: "새로 고침",
      NewSubscription: "새 구독 - {0}",
      NewSubscriptionDescription: "조직에 새 구독이 있습니다.",
      NewSubscriptionAction: "자세히 알아보기",
      SubscriptionExpired: "구독이 만료됨 - {0}",
      SubscriptionExpiredDescription: "{0}에 구독이 만료됨",
      SubscriptionExpiredAction: "구독 보기",
      Subscription30DayWarning: "구독 만료 예정 - {0}",
      Subscription30DayWarningDescription: "귀하의 구독은 {0}일 뒤 {1}에 만료됩니다.",
      Subscription30DayWarningAction: "구독 보기",
      Subscription15DayWarning: "구독이 곧 만료됨 - {0}",
      Subscription15DayWarningDescription: "귀하의 구독은 {0}일 뒤 {1}에 만료됩니다.",
      Subscription15DayWarningAction: "구독 보기",
      JoinOrgRequestAccepted: "조직 가입 요청 승인됨",
      JoinOrgRequestAcceptedDescription: "<b>{0}</b>에 대한 액세스 권한을 부여받았습니다",
      JoinOrgRequestSwitch: "조직 열기",
      JoinOrgRequestDenied: "조직 가입 요청 거부됨",
      JoinOrgRequestDeniedDescription: "관리자가 <b>{0}</b>에 대한 가입 요청을 거부했습니다",
      NonHPContext: "비 HP 컨텍스트 창 열기",
      NonHPContextDescription: "컨텍스트: {0}",
      CloseContext: "컨텍스트 닫기"
    },
    ui: {
      Confirm: "확인",
      Notify: "알림",
      OpenImage: "이미지 파일 열기",
      Dismiss: "취소",
      CheckingContext: "컨텍스트 확인 중...",
      LoadingContext: "{0} 복구 중..."
    }
  }
};
